export const SHORTLIST_PAGE_TITLE = 'Your shortlisted cars';
export const SHORTLIST_COMPARE_MAX = 3;
/** Public icon path segment (used with assetLoader) — white info glyph for compare tray. */
export const SHORTLIST_COMPARE_INFO_WHITE_ICON = "icons/info_white.svg";
export const SHORTLIST_PRICING_BATCH_SIZE = 3;
export const SHORTLIST_PRICING_MOBILE_BATCH_SIZE = 1;
export const MMV_CDN_HERO_IMAGE_TAG = "Transparent";

export const SHORTLIST_LABELS = {
  EXPERT_RATING_SUFFIX: 'expert rating',
  EXPLORE_CAR: 'Explore this car',
  VARIANT_LABEL: 'Variant:',
  COLOUR_LABEL: 'Colour:',
  OUR_PRICE: 'Our price:',
  EMI_PREFIX: 'EMI from',
  SAVINGS_PREFIX: "You'll save",
  SAVINGS_SUFFIX: 'with ACKO Drive',
  SEE_PRICE_BREAKUP: 'See price breakup',
  GET_A_QUOTE: 'Get a quote',
  HELP_ME_BUY: 'Help me buy',
  COMPARE: 'Compare',
  DELIVERY_BY: 'Delivery by',
  EXPRESS_DELIVERY_BY: 'Express delivery by',
  DELETE_ARIA: 'Remove from shortlist',
  COMPARE_ARIA: 'Add to compare',
  SELECT_VARIANT: 'Select a variant',
  SELECT_COLOUR: 'Select a colour',
  PRICE_BREAKUP: 'Price breakup',
  COMPARE_VARIANTS_LABEL: 'Not sure which variant to pick?',
  COMPARE_VARIANTS_CTA: 'Compare variants',
  UNAVAILABLE: 'Unavailable',
  SAVE_PREFIX: 'Save',
  TOTAL_PRICE: 'Total on-road price',
  UNAVAILABLE_VARIANT_BANNER: (cityName: string) => `This variant is unavailable in ${cityName}`,
  UNAVAILABLE_COLOUR_BANNER: (cityName: string) => `This colour is unavailable in ${cityName}`,
  COMPARE_LIMIT_ERROR: `You can only compare up to 3 variants`,
  COMPARE_NOW: 'Compare now',
  REMOVE_ALL: 'Remove all',
  COMPARE_SELECT_TITLE: 'Select variants to compare',
  COMPARE_SELECT_MIN: 'Select at least 2 variants to compare',
  COMPARE_ADD_ANOTHER_INFO: 'Add another car to compare',
  COMPARE_CTA: 'Compare',
  PRICING_SHIMMER_TEXT: 'Fetching latest price and\ndelivery details...',
} as const;

export const PRICE_BREAKUP_LABELS = {
  TITLE: "Price breakup",
  EX_SHOWROOM: "Ex-showroom price",
  OTHER_CHARGES: "Other charges",
  TOTAL_DISCOUNT: "Total discount",
  ACKO_DISCOUNT: "ACKO Drive discount",
  CONSUMER_DISCOUNT: "Consumer discount",
  ACKO_DRIVE_PRICE: "ACKO Drive price",
  DID_YOU_KNOW_PREFIX: "Did you know?",
  DID_YOU_KNOW_TEXT:
    " You pay less with ACKO Drive because we don't charge dealer commissions.",
} as const;

export const PRICE_BREAKUP_KEY_LABEL_OVERRIDES: Record<string, string> = {
  fast_tag: 'FASTag',
};
